
export interface AdUnitScreenSizeConfig {
    minScreenWidth: number;
    bannerSizes: Array<[number, number]>;
    native: boolean;
}

export declare type AdUnitSizeConfig = AdUnitScreenSizeConfig[];

export const billboard: AdUnitSizeConfig = [
    {
        minScreenWidth: 980, // desktop
        bannerSizes: [
            [980, 250], [980, 120], [980, 90],
            [970, 250], [970, 90],
            [960, 90],
            [950, 90],
            [930, 180],
            [800, 250], [800, 90],
            [768, 90],
            [750, 200], [750, 100],
            [728, 90],
        ],
        native: false,
    },
    {
        minScreenWidth: 0, // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const rectangleDesktopOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 980, // desktop
        bannerSizes: [[336, 280], [300, 250], [250, 250]],
        native: true,
    },
    {
        minScreenWidth: 0, // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const rectangleMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile (iphone4 - 320px)
        bannerSizes: [[336, 280], [300, 250], [250, 250]],
        native: true,
    },
];

export const rectangleMobileOnlyV2: AdUnitSizeConfig = [
    // Rectangle formats including 300x300 square (no halfpage)
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [[250, 250], [300, 250], [300, 300], [336, 280]],
        native: true,
    },
];

export const halfpageDesktopOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 980, // desktop
        bannerSizes: [[300, 600], [160, 600], [120, 600]],
        native: true,
    },
    {
        minScreenWidth: 0,  // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const halfpageMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 980, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [[300, 600], [160, 600], [120, 600]],
        native: true,
    },
];

export const rectangleOrHalfpageMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [[250, 250], [300, 250], [300, 300], [300, 600], [336, 280]],
        native: true,
    },
];

export const rectangleOrHalfpageDesktopOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop
        bannerSizes: [[250, 250], [300, 250], [300, 300], [300, 600], [336, 280]],
        native: true,
    },
    {
        minScreenWidth: 0,  // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const halfpageOffsite: AdUnitSizeConfig = [
    {
        minScreenWidth: 1590, // desktop (1590 - 980 stranka - 10 margin) / 2 >= 300
        bannerSizes: [[300, 600], [160, 600], [120, 600]],
        native: false,
    },
    {
        minScreenWidth: 1310, // desktop  (1310 - 980 stranka - 10 margin) / 2 >= 160
        bannerSizes: [[160, 600], [120, 600]],
        native: false,
    },
    {
        minScreenWidth: 1230, // desktop  (1230 - 980 stranka - 10 margin) / 2 >= 120
        bannerSizes: [[120, 600]],
        native: false,
    },
    {
        minScreenWidth: 0, // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const brandingDesktopOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 980, // desktop
        bannerSizes: [[2000, 1400], [970, 250]],
        native: false,
    },
    {
        minScreenWidth: 0, // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const brandingDesktopOnlyV2: AdUnitSizeConfig = [
    {
        minScreenWidth: 980, // desktop
        bannerSizes: [[970, 250]],
        native: false,
    },
    {
        minScreenWidth: 0, // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const brandingMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [[420, 125], [420, 122], [400, 125], [390, 122], [375, 125], [374, 117], [360, 125], [358, 112], [320, 125], [320, 100]],
        native: false,
    },
];

export const brandingMobileOnlyV2: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [
            [990, 250],
            [990, 200],
            [990, 90],
            [970, 250],
            [970, 90],
            [728, 200],
            [728, 90],
            [320, 100],
            [320, 50],
            [300, 150],
            [300, 50],
        ],
        native: true,
    },
];

// Market Section mobile ad configurations

// For Top 01, Mid 01, Other 01 - includes halfpage (300x600)
export const marketSectionWithHalfpageMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [
            [336, 280],
            [300, 600],
            [300, 300],
            [300, 250],
            [250, 250],
        ],
        native: true,
    },
];

// For Mid 02, Mid 03 - without halfpage
export const marketSectionWithoutHalfpageMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [
            [336, 280],
            [300, 300],
            [300, 250],
            [250, 250],
        ],
        native: true,
    },
];

export const bannerMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,
        bannerSizes: [
            [250, 250],
            [300, 250],
            [300, 300],
            [300, 600],
            [336, 280],
        ],
        native: true,
    },
];

export const leaderboardMobileOnly: AdUnitSizeConfig = [
    // mobile leaderboard ads are able to downscale
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0, // mobile
        bannerSizes: [

            [300, 50],
            [320, 100],
            [320, 50],
            [350, 90],
            [468, 60],
            [728, 90],
            [970, 210],
            [970, 250],
        ],
        native: false,
    },
];

export const leaderboardMobileOnlyV2: AdUnitSizeConfig = [
    // mobile leaderboard ads are able to downscale
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,
        bannerSizes: [
            [320, 100],
            [320, 50],
            [728, 200],
            [728, 90],
            [970, 250],
            [970, 90],
            [990, 200],
            [990, 250],
            [990, 90],
        ],
        native: false,
    },
];

export const mail: AdUnitSizeConfig = [
    {
        minScreenWidth: 0,
        bannerSizes: [[730, 3000]],
        native: true,
    },
];

export const mailCtaButton: AdUnitSizeConfig = [
    {
        minScreenWidth: 0,
        bannerSizes: [],
        native: true,
    },
];

export const nativeRectangleDesktopOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 980, // desktop
        bannerSizes: [[336, 280]],
        native: true,
    },
    {
        minScreenWidth: 0, // mobile (not shown)
        bannerSizes: [],
        native: false,
    },
];

export const nativeRectangleMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        minScreenWidth: 0,  // mobile
        bannerSizes: [[336, 280]],
        native: true,
    },
];

// https://support.google.com/admanager/answer/6015986?hl=en
export const interstitialDesktopOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [
            [1, 1],
            // [1024, 768] - neodskusane, nepouzivane
        ],
        native: false,
    },
    {
        // Creative is wider than screen width. When displaying, we center it
        // inside slot and hide parts that overflow
        minScreenWidth: 0,  // mobile (iphone4 - 320px; up to iphone 6+ - 416px)
        bannerSizes: [],
        native: false,
    },
];

// https://support.google.com/admanager/answer/6015986?hl=en
export const interstitialMobileOnly: AdUnitSizeConfig = [
    {
        minScreenWidth: 600, // desktop (not shown)
        bannerSizes: [],
        native: false,
    },
    {
        // Creative is wider than screen width. When displaying, we center it
        // inside slot and hide parts that overflow
        minScreenWidth: 0,  // mobile (iphone4 - 320px; up to iphone 6+ - 416px)
        bannerSizes: [[1, 1]],
        native: false,
    },
];
